"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToken = exports.setEnv = exports.getMetaMaskAddress = exports.isConnectedMeta = exports.sendMetaMaskContractTx = exports.getMetaAccounts = exports.changeChain = exports.getCurChainId = void 0;
var onboarding_1 = __importDefault(require("@metamask/onboarding"));
var ethers_1 = require("ethers");
var sweetalert2_1 = __importDefault(require("sweetalert2"));
var error_1 = __importDefault(require("./error"));
var meta_storage_key = 'meta_address';
var chainIds = [1, 4, 435, 1337];
var isConnectedMetaMask = false;
var metaMaskNetworkStatus = false;
var env = 'prod';
var _disableTooltip = false;
function convert16(num) {
  return ethers_1.ethers.utils.hexValue(ethers_1.BigNumber.from(num).toHexString());
}
function error(msg) {
  var iconStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';
  if (!_disableTooltip) {
    var toast = sweetalert2_1.default.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: function didOpen(toast) {
        toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
        toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
      }
    });
    toast.fire({
      icon: iconStr,
      title: msg || 'Some errors occured'
    });
  }
}
function getCurChainId() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return window.ethereum.request({
            method: 'eth_chainId'
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
exports.getCurChainId = getCurChainId;
function addChain(chainid, chain) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var ethChain;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          ethChain = convert16(chainid);
          _context2.next = 4;
          return window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
              chainId: ethChain,
              chainName: chain.name,
              nativeCurrency: {
                name: '',
                symbol: chain.symbol,
                decimals: 18
              },
              rpcUrls: [chain.url]
            }]
          });
        case 4:
          return _context2.abrupt("return", true);
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          error(_context2.t0.message);
        case 10:
          return _context2.abrupt("return", false);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
}
function changeChain(chainid, chain) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var eth_chainid, addRes;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          eth_chainid = "0x" + chainid.toString(16);
          _context3.prev = 1;
          _context3.next = 4;
          return window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{
              chainId: eth_chainid
            }]
          });
        case 4:
          return _context3.abrupt("return", true);
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](1);
          if (!(_context3.t0.code === 4902 && chain != null)) {
            _context3.next = 14;
            break;
          }
          _context3.next = 12;
          return addChain(chainid, chain);
        case 12:
          addRes = _context3.sent;
          return _context3.abrupt("return", addRes);
        case 14:
          return _context3.abrupt("return", false);
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 7]]);
  }));
}
exports.changeChain = changeChain;
function getMetaAccounts() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var metamaskAddress, onboarding, accounts;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          metamaskAddress = '';
          if (onboarding_1.default.isMetaMaskInstalled()) {
            _context4.next = 7;
            break;
          }
          error('MetaMask Not Install.');
          onboarding = new onboarding_1.default();
          onboarding.stopOnboarding();
          _context4.next = 20;
          break;
        case 7:
          _context4.prev = 7;
          window.ethereum.on('chainChanged', function (chainId) {
            var chainNum = window.parseInt(parseInt(chainId), 10);
            localStorage.setItem('metachain', chainNum);
            metaMaskNetworkStatus = chainIds.indexOf(chainNum) < 0;
          });
          window.ethereum.on('accountsChanged', function (accounts) {
            if (accounts.length > 0) {
              metamaskAddress = accounts[0];
              localStorage.setItem('meta_address', metamaskAddress);
            }
          });
          _context4.next = 12;
          return window.ethereum.request({
            method: 'eth_requestAccounts'
          });
        case 12:
          accounts = _context4.sent;
          if (accounts.length > 0) {
            metamaskAddress = accounts[0];
            localStorage.setItem(meta_storage_key, metamaskAddress);
            isConnectedMetaMask = true;
          }
          _context4.next = 19;
          break;
        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4["catch"](7);
          if (_context4.t0.code === -32002) {
            error('Already processing connecting metamask. Please open or unlock Metamask .', 'info');
          } else {
            error(_context4.t0.message);
          }
        case 19:
          return _context4.abrupt("return", metamaskAddress);
        case 20:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[7, 16]]);
  }));
}
exports.getMetaAccounts = getMetaAccounts;
function sendMetaMaskContractTx(trans, chain) {
  var disableTooltip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var fromAddrees, isok, metaAddr, curMetaChain, provider, signer, daiAddress, daiAbi, contract, daiWithSigner, overrides, metaTx, gasLimit, gasPrice, nonce, txhash, metaFrom, metaTo, transRes, errMsg;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _disableTooltip = disableTooltip;
          fromAddrees = trans.eth_address;
          isok = true;
          _context5.next = 5;
          return getMetaAccounts();
        case 5:
          metaAddr = _context5.sent;
          if (!(metaAddr === '')) {
            _context5.next = 8;
            break;
          }
          return _context5.abrupt("return", null);
        case 8:
          if (!(fromAddrees.toLocaleLowerCase() !== metaAddr.toLocaleLowerCase().replaceAll('"', ''))) {
            _context5.next = 10;
            break;
          }
          return _context5.abrupt("return", {
            success: false,
            code: error_1.default.MM_ACCOUNT_NOT_MATCH,
            data: "Invalid MetaMask address, it should be: ".concat(fromAddrees)
          });
        case 10:
          _context5.next = 12;
          return getCurChainId();
        case 12:
          curMetaChain = _context5.sent;
          if (!(trans.chainid !== curMetaChain)) {
            _context5.next = 17;
            break;
          }
          _context5.next = 16;
          return changeChain(trans.chainid, chain);
        case 16:
          isok = _context5.sent;
        case 17:
          if (isok) {
            _context5.next = 19;
            break;
          }
          return _context5.abrupt("return", {
            success: false,
            code: error_1.default.MM_SWITCH_CHAIN_CANCEL,
            data: "chain is error "
          });
        case 19:
          _context5.prev = 19;
          provider = new ethers_1.ethers.providers.Web3Provider(window.ethereum);
          signer = provider.getSigner(trans.eth_address);
          daiAddress = trans.contract_address;
          daiAbi = [trans.func_abi_sign];
          contract = new ethers_1.ethers.Contract(daiAddress, daiAbi, provider);
          daiWithSigner = contract.connect(signer);
          overrides = {
            value: trans.value
          };
          _context5.next = 29;
          return daiWithSigner[trans.function].apply(daiWithSigner, _toConsumableArray(trans.args).concat([overrides]));
        case 29:
          metaTx = _context5.sent;
          gasLimit = metaTx['gasLimit']['_hex'];
          gasPrice = metaTx['gasPrice']['_hex'];
          nonce = metaTx['nonce'];
          txhash = metaTx['hash'];
          metaFrom = metaTx['from'];
          metaTo = metaTx['to'];
          transRes = {
            chainid: trans.chainid,
            domain: trans.domain,
            from: metaFrom,
            to: metaTo,
            function: trans.function,
            args: trans.args,
            trans: {
              gasLimit: gasLimit,
              gasPrice: gasPrice,
              txhash: txhash,
              nonce: nonce
            }
          };
          return _context5.abrupt("return", {
            success: true,
            data: transRes
          });
        case 40:
          _context5.prev = 40;
          _context5.t0 = _context5["catch"](19);
          errMsg = _context5.t0.message;
          if (_context5.t0.data) {
            errMsg += '|' + _context5.t0.data.message;
          }
          if (!disableTooltip) {
            error("MetaMask Transfer Error ".concat(_context5.t0.message));
          }
          return _context5.abrupt("return", {
            success: false,
            code: error_1.default.MM_ERROR,
            data: errMsg
          });
        case 46:
          return _context5.abrupt("return", {
            success: false,
            data: 'not defined error'
          });
        case 47:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[19, 40]]);
  }));
}
exports.sendMetaMaskContractTx = sendMetaMaskContractTx;
function isConnectedMeta() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var accounts;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return getMetaAccounts();
        case 2:
          accounts = _context6.sent;
          return _context6.abrupt("return", !!accounts && accounts.length > 0);
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
}
exports.isConnectedMeta = isConnectedMeta;
function getMetaMaskAddress() {
  return localStorage.getItem(meta_storage_key);
}
exports.getMetaMaskAddress = getMetaMaskAddress;
function setEnv(_env) {
  env = _env;
}
exports.setEnv = setEnv;
function addToken(token, tokenAddress, tokenDecimals, tokenImage) {
  var chainObj = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var symbol, address, decimals, image, chain, curMetaChain, chainChangeOk;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          symbol = '', address = '', decimals = 18, image = '';
          if (typeof token === 'object') {
            symbol = token.token;
            address = token.tokenAddress;
            decimals = token.tokenDecimals;
            image = token.tokenImage;
          } else {
            symbol = token;
            address = tokenAddress;
            decimals = tokenDecimals;
            image = tokenImage;
          }
          if (!(chainObj || token['chainId'])) {
            _context7.next = 13;
            break;
          }
          _context7.next = 5;
          return getCurChainId();
        case 5:
          curMetaChain = _context7.sent;
          chainChangeOk = true;
          if (!(convert16(chainObj.chainId) !== curMetaChain)) {
            _context7.next = 11;
            break;
          }
          _context7.next = 10;
          return changeChain(chainObj.chainId, chainObj);
        case 10:
          chainChangeOk = _context7.sent;
        case 11:
          if (chainChangeOk) {
            _context7.next = 13;
            break;
          }
          return _context7.abrupt("return", Promise.reject({
            success: false,
            code: error_1.default.MM_SWITCH_CHAIN_CANCEL,
            data: 'chain change error '
          }));
        case 13:
          return _context7.abrupt("return", window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20',
              options: {
                address: address,
                symbol: symbol,
                decimals: decimals,
                image: image
              }
            }
          }));
        case 14:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
}
exports.addToken = addToken;
exports.default = {
  getMetaMaskAddress: getMetaMaskAddress,
  isConnectedMeta: isConnectedMeta,
  getMetaAccounts: getMetaAccounts,
  getCurChainId: getCurChainId,
  sendMetaMaskContractTx: sendMetaMaskContractTx,
  changeChain: changeChain,
  setEnv: setEnv,
  addToken: addToken
};